export enum Layer3dState {
    CREATED,
    INITIALIZED,
    READY,
    DESTROYED,
}
